/** Progresso do roteiro agregado no servidor, independente da paginação da agenda. */
import { providerCompletionPercent } from '@/lib/providerPortalDisplay';

export function ProviderDailyProgress({ total, done }: { total?: number; done?: number }) {
  const percent = providerCompletionPercent(done, total);
  return <div className="flex shrink-0 items-center gap-2" aria-label="Progresso das OS do dia">
    <div className="relative h-16 w-16 shrink-0">
      <svg viewBox="0 0 64 64" className="h-full w-full -rotate-90" aria-hidden="true">
        <circle cx="32" cy="32" r="27" fill="none" stroke="currentColor" strokeWidth="5" className="text-border" />
        <circle cx="32" cy="32" r="27" fill="none" stroke="currentColor" strokeWidth="5" pathLength="100" strokeDasharray={`${percent ?? 0} 100`} strokeLinecap="round" className="text-success" />
      </svg>
      <span className="absolute inset-0 flex items-center justify-center text-sm font-bold tabular-nums">{percent == null ? '—' : `${percent}%`}</span>
    </div>
    <div className="max-w-20 text-xs"><p className="font-semibold">OS do dia</p><p className="mt-1 text-muted-foreground tabular-nums">{total === 0 ? 'Sem OS hoje' : total == null || done == null ? '—' : `${done} de ${total} OS`}</p></div>
  </div>;
}